import TextScroll from '../../components/textScroll';
import isEqual from 'lodash/isEqual';
import { hexToRgb } from '../../utils/utils';
function setSceneTextScroll(data) {
  if (JSON.stringify(data) != '{}') {
    const bgRgb = hexToRgb(data.bgcolor);
    const textColor = data.css.color;

    const newData = {
      content: data.text,
      wrapperStyle: {
        height: `${data.height}px`,
        backgroundColor: `rgba(${bgRgb.r},${bgRgb.g},${bgRgb.b},${data.bgalpha})`,
      },
      textStyle: {
        ...data.css,
        color: `rgba(${textColor.r},${textColor.g},${textColor.b},${textColor.a})`,
      },
      speed: data.speed,
      duration: data.interval_time,
    }
    if (this.scenescrollText) {
      if (isEqual(newData, this.scenescrollText.params)) return;
      this.scenescrollText.remove();
    }

    if (!newData) return;

    this.scenescrollText = new TextScroll({
      ...newData,
      wrapper: this.$container.get(0),
    });
  }else{
    if (this.scenescrollText) {
      this.scenescrollText.remove();
    }
  }
}

export default {
  setSceneTextScroll,
};
